<template>
  <div class="text-center mb-12">
    <h1 class="text-4xl font-bold text-brand-800 mb-3">RFIs Management</h1>
    <p class="text-lg text-gray-600">
      View and manage all Request for Information
    </p>
  </div>
</template>

<script>

</script>